import { l } from '../../../lib/imports'
import { common } from '../../../main/common-sidecar'
import { golfPucks } from '../actors/golfPucks-sidecar'
import { golfMessagePuckUpdate } from '../messages/golfMessagePuckUpdate-sidecar'
import { golfWebsockets } from '../messages/golfWebsockets-sidecar'
import { golfPhysicsTest } from './golfPhysicsTest-sidecar'

let updateTimer = 0
let updateTime = 0.25
export function update() {
  let ds = common.getUpdateDeltaScaled()

  updateTimer += ds

  if (updateTimer > updateTime) {
    updateTimer = 0
    if (golfWebsockets.getIsHost()) {
      l.forEach(golfPucks.getAll(), (c) => {
        let pos = c.body.getPosition()
        let vel = c.body.getLinearVelocity()

        golfMessagePuckUpdate.sendMessageAndImmediatelyExecute({
          pieceId: c.id,
          frame: golfPhysicsTest.getFrame(),
          pos: pos,
          vel: vel,
        })
      })
    }
  }
}
